import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { RelativeTime } from '@bonusly/common-relative-time';
import { Box, Flex, Text } from '@bonusly/design-system';

import { useEvaluation } from './context';

interface CompleteBadgeProps {
	isNew: boolean;
}

export const CompleteBadge: FC<CompleteBadgeProps> = ({ isNew }) => {
	const { t } = useTranslation('feedback');
	const evaluation = useEvaluation();
	const message = evaluation.lastMessage();

	if (!message || !evaluation.isComplete()) {
		return null;
	}

	return (
		<Flex alignItems="center">
			<Text size="sm" color="text.softest">
				<Trans i18nKey="request.active_time" t={t}>
					Active
					<RelativeTime color="text.softest" date={message.createdAt} fontSize="sm" />
				</Trans>
			</Text>

			{isNew && <Box boxSize={2} borderRadius="full" bg="red.400" ml={2} />}
		</Flex>
	);
};
